import { InjectionToken } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const USE_US_SPORT_ICONS: InjectionToken<boolean> = new InjectionToken<boolean>('useUsSportIcons', {
  factory: () => false
});
